import Screen from '../../../../shared/utils/screen';

function StarIcon() {
  return (
    <>
      <svg
        width={36 * Screen.widthRatio}
        height={35 * Screen.widthRatio}
        viewBox='0 0 36 35'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M34.6547 11.9549L24.1202 10.4231L19.4072 0.874837C18.8316 -0.291647 17.1682 -0.291577 16.5926 0.874837L11.8798 10.4232L1.3453 11.955C0.0581605 12.1421 -0.455754 13.7239 0.475606 14.6318L8.09804 22.0626L6.29945 32.5562C6.07972 33.8381 7.42529 34.8157 8.57659 34.2105L17.8912 29.2568L27.3149 34.2104C28.5744 34.8156 29.92 33.838 29.7003 32.5561L27.9018 22.0626L35.5243 14.6316C36.4558 13.7237 35.9419 12.142 34.6547 11.9549Z'
          fill='#FFE600'
        />
      </svg>
    </>
  );
}

export default StarIcon;
